import { api } from 'api'
import { UrlAuditRoutes } from 'routes'

const POLLERS = {}
export class LinkValidationPoller {
  static getPoller(datasetUuid) {
    if (POLLERS[datasetUuid]) {
      return POLLERS[datasetUuid]
    }
    const poller = new LinkValidationPoller(datasetUuid)
    POLLERS[datasetUuid] = poller
    return poller
  }

  constructor(datasetUuid) {
    this.datasetUuid = datasetUuid
    this.startTime = null
    this.endTime = null
    this.onResultsCallback = () => {}
  }

  onResults(fn) {
    // we only allow one...
    // There should be a poller per datasetUuid.  So that should be fine.
    this.onResultsCallback = fn
  }

  /**
   *
   */
  start() {
    // if it's already running, don't do anything
    if (this.startTime) {
      return
    }

    this.startTime = Date.now()
    this.endTime = null

    this.poll()
  }

  /**
   *
   */
  poll() {
    // don't continue polling if the the end time is set.  Break the cycle.
    if (this.endTime) {
      return
    }

    const waitTimeSeconds = getWaitTimeSeconds(this.startTime)

    setTimeout(() => {
      api
        .get(UrlAuditRoutes.results(this.datasetUuid))
        .then(response => {
          this.handleResults(response)
          this.poll()
        })
        .catch(() => {
          this.cancelPolling()
        })
    }, waitTimeSeconds * 1000)
  }

  /**
   *
   * @param response
   */
  handleResults(response) {
    const { data } = response

    // call the results callback if set
    this.onResultsCallback && this.onResultsCallback(data)
    // if everything is done, cancel the polling
    const pending = data.filter(result => {
      return result.status === 1
    })
    if (pending && pending.length === 0) {
      this.cancelPolling()
    }
  }

  /**
   *
   */
  cancelPolling() {
    this.startTime = null
    this.endTime = Date.now()
    this.onResultsCallback = () => {}
  }
}

const ONE_MINUTE = 1 * 60
const FIVE_MINUTES = 5 * 60
const FIFTEEN_MINUTES = 15 * 60
const THIRTY_MINUTES = 15 * 60
const ONE_HOUR = 1 * 60 * 60
const THREE_HOURS = 3 * 60 * 60
const SIX_HOURS = 6 * 60 * 60

function getWaitTimeSeconds(startTimeMs) {
  const secondsSinceStart = (Date.now() - startTimeMs) / 1000
  if (secondsSinceStart < ONE_MINUTE) {
    return 5
  }
  if (secondsSinceStart < FIVE_MINUTES) {
    return 15
  }
  if (secondsSinceStart < FIFTEEN_MINUTES) {
    return 60
  }
  if (secondsSinceStart < THIRTY_MINUTES) {
    return 90
  }
  if (secondsSinceStart < ONE_HOUR) {
    return 150
  }
  if (secondsSinceStart < THREE_HOURS) {
    return 300
  }
  if (secondsSinceStart < SIX_HOURS) {
    return 600
  }
  return 600
}
